export default __webpack_public_path__ + "static/media/exportPink.aba9fcff.svg";